/**
 * Base Application Dependencies
 */
import Vue from 'vue'
import App from './App'
import Vuex from 'vuex'
import router from './router'
import EventBus from './events'
import store from './state/store'
import * as Filters from './filters'
import Directives from './directives'
import { sync } from 'vuex-router-sync'
import VueAnalytics from 'vue-analytics'
import GlobalComponents from './components'

// Stylesheet
require('./styles/app.scss')

/**
 * Global Filters
 */
Object.keys(Filters).forEach(
    filter => Vue.filter(filter, Filters[filter])
)

/**
 * Global Directives
 */
Object.keys(Directives).forEach(
    directive => Vue.directive(directive, Directives[directive])
)

/**
 * Global Components
 */
Object.keys(GlobalComponents).forEach(
    component => Vue.component(component, GlobalComponents[component])
)

/**
 * Sync router with Vuex
 */
sync(store, router)

/**
 * Vue Plugins
 */
Vue.use(Vuex)

if (process.env.NODE_ENV === 'production') {
    Vue.use(VueAnalytics, {
        id: process.env.GA_CODE,
        router,
        autoTracking: {
            pageviewOnLoad: false
        }
    })
}

/**
 * Add additional Vue properties
 */
Object.defineProperties(Vue.prototype, {
    $bus: {
        get: function () {
            return EventBus
        }
    }
})

/* eslint-disable no-new */
new Vue({
    el: '#app',
    store,
    router,
    template: '<App/>',
    components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js